import { render, staticRenderFns } from "./PersonProfileDirectMatch.vue?vue&type=template&id=dcc431c4&scoped=true&"
import script from "./PersonProfileDirectMatch.vue?vue&type=script&lang=js&"
export * from "./PersonProfileDirectMatch.vue?vue&type=script&lang=js&"
import style0 from "./PersonProfileDirectMatch.vue?vue&type=style&index=0&id=dcc431c4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc431c4",
  null
  
)

export default component.exports